import React, { useEffect, useState } from 'react'
import useAuth from "@/hooks/useAuth"
import { useGetUserConversationsQuery } from '@/features/userConversations/userConversationsApiSlice'

import EtModalUpdateUserMeetingPrep from '@/components/common/modal/EtModalUpdateUserMeetingPrep'
import EtModalTrinityUserMeetingConversation from '@/components/common/modal/EtModalTrinityUserMeetingConversation'

import {
  PlusIcon,
  MinusIcon,
  PencilSquareIcon,
  TrashIcon,
} from "@heroicons/react/24/outline"

import { 
  ClockIcon, 
  CalendarDaysIcon, 
  UserGroupIcon,
  ArrowPathIcon,
  DocumentTextIcon,
  ArrowTrendingUpIcon,
  ShareIcon,
  CheckCircleIcon, 
} from "@heroicons/react/24/solid"

import EtMeetingIcon1SVGComp from '@/assets/img/icons/svgComp/EtMeetingPrepIcon1SVGComp'
import EtMeetingIcon2SVGComp from '@/assets/img/icons/svgComp/EtMeetingIcon1SVGComp'
import EtWabConversationIcon1SVGComp from "@/assets/img/icons/svgComp/EtWabConversationIcon1SVGComp" 
import EtWabActionIcon1SVGComp from "@/assets/img/icons/svgComp/EtWabActionIcon1SVGComp" 

import moment from "moment";
import { getTimeSince } from "@/utils/EtGetTimeSince"

// 12 Jun 2025
import { CircularProgressbarWithChildren } from 'react-circular-progressbar'
import EtModalUpdateUserAction from '@/components/common/modal/EtModalUpdateUserAction'

const EtPostMeetingCard = ({ 
    event, 
    index, 
    activeTab, 
    matchingPrep=[],
    isActive = false, 
    onClick,
    userEmail = "", // 21 May 2025  
    relevantContacts = [], // 22 May 2025  
}) => {
  // Author - Atul Pandey
  // First Created - 20 May 2025
  // Purpose - To display each event details
  // Inherited from MeetingCard component inside EtTrinityWebLandingAction
  // Updated - 21 May 2025 - Added Trinity AI guided meeting prep generation
  // Updated - 21 May 2025 - Added RTK mutation for generateUserMeetingPrepBrief
  // Updated - 21 May 2025 - Switched to useAuth token method instead of RTK mutation for streaming data
  // Updated - 21 May 2025 - Added userEmail prop to determine meeting type
  // Updated - 22 May 2025 - Added contact matching logic by getting the Contacts data via relevantContacts prop
  // Updated - 12 Jun 2025 - Added contact conversations display logic
  // Updated - 12 Jun 2025 - Added actions (connected to conversations) display logic


  // Original Update Trail
  // ----------------------
  // First Created - 21 Mar 2025
  // Purpose - To display each event details
  // Updated - 22 Mar 2025 - To edit or delete a specific note
  // Updated - 22 Mar 2025 - Post Meeting actions section
  // Updated - 23 Mar 2025 - Post Meeting Conversations capture and display
  // Updated - 25 Mar 2025 - Post Meeting Conversations - show conversation details
  
  // 0 - Validate incoming data
  // console.log('matchingPrep in MeetingCard', matchingPrep)
  // console.log('event in MeetingCard', event)
  console.log('event has conversation in MeetingCard', event.hasConversation)
  // console.log('event id in MeetingCard', event?._id)
  // console.log('matchingPrep id in MeetingCare', matchingPrep?._id)

  // 1 - State variables
  const [showAttendees, setShowAttendees] = useState(false)
  const [showDetails, setShowDetails] = useState(false)
  const [showNoteDetails, setShowNoteDetails] = useState({})
  const [showModal, setShowModal] = useState(false);
  const [selectedNoteId, setSelectedNoteId] = useState(null);  // ✅ 22 Mar 2025 - new
  const [isDeletingNote, setIsDeletingNote] = useState(false); // ✅ 22 Mar 2025 - new
  const [activePostTab, setActivePostTab] = useState('conversations') // ✅ 22 Mar 2025 - new
  const [showConversationModal, setShowConversationModal] = useState(false); // ✅ 23 Mar 2025 - new
  
  const [showConversationDetails, setShowConversationDetails] = useState({}) // ✅ 25 Mar 2025 - new
  const [selectedConversationNoteId, setSelectedConversationNoteId] = useState(null);  // ✅ 25 Mar 2025 - new
  const [isDeletingConversationNote, setIsDeletingConversationNote] = useState(false); // ✅ 25 Mar 2025 - new

  // 21 May 2025 - Trinity AI Stream State
  const [isGeneratingAI, setIsGeneratingAI] = useState(false);
  const [aiGeneratedBrief, setAiGeneratedBrief] = useState('');
  const [showAIPrepModal, setShowAIPrepModal] = useState(false); // 💬 Modal visibility

  // 12 Jun 2025 - Action Details
  const [expandedActions, setExpandedActions] = useState({});
  const [expandedActionDetails, setExpandedActionDetails] = useState({}); 
  const [expandedProgressTrail, setExpandedProgressTrail] = useState({});
  const [showUpdateModal, setShowUpdateModal] = useState(false)           
  const [selectedAction, setSelectedAction] = useState(null)               

  // 21 May 2025 - Determine Meeting Types
  // const isOneOnOneMeeting =
  // event?.attendees?.length === 2 &&
  // event.attendees.filter(a => a.email !== userEmail).length === 1;

  // 22 May 2025 - Determining Meeting Types
  const externalAttendees = event?.attendees?.filter(a => a.email !== userEmail) || [];
  const matchingContact = relevantContacts.find(contact => {
    const contactEmails = (contact.contactEmailList || []).map(e => e.email).filter(Boolean);
    return (
      externalAttendees.length === contactEmails.length &&
      externalAttendees.every(att => contactEmails.includes(att.email))
    );
  });

  const isOneOnOneMeeting = externalAttendees.length === 0
  ? false
  : Boolean(matchingContact);

  // console.log('matchingContact', matchingContact)
  // console.log('isOneOnOneMeeting', isOneOnOneMeeting)


  // 2 - Get Data 
  const { 
    data: userConversationsData,
    isLoading: isLoadingUserConversations, // ✅ 25 Mar 2025
    refetch: refetchUserConversations // ✅ 25 Mar 2025 Extract refetch
  
  } = useGetUserConversationsQuery() //  ✅ 23 Mar 2025 - Fetch all user conversations

  // console.log('User Conversations Data', userConversationsData)

  // 21 May 2025
  // const [generateUserMeetingPrepBrief] = useGenerateUserMeetingPrepBriefMutation()
  const { token } = useAuth();
  
  // ✅ Filter conversations that belong to this meeting (by meetingPrepId or calendarMeetingId)
  const extractMeetingConversations = () => {
    if (!userConversationsData?.ids?.length || !userConversationsData?.entities) return [];
  
    const allNotes = [];
  
    userConversationsData?.ids.forEach((id) => {
      const conv = userConversationsData.entities[id];
      
      // 1️⃣ Process self notes
      (conv?.userConversationAllNotes || [])?.forEach((note) => {
        if (
          note.calendarMeetingId === event._id ||
          note.userMeetingPrepId === matchingPrep?._id
        ) {
          allNotes.push({
            ...note,
            noteType: 'self',
          });
        }
      });
  
      // 2️⃣ Process contact notes
      (conv?.userConversationContactNotes || [])?.forEach((note) => {
        if (
          note.calendarMeetingId === event._id ||
          note.userMeetingPrepId === matchingPrep?._id
        ) {
          allNotes.push({
            ...note,
            noteType: 'contact',
            contactName: note.userContactId?.contactName || '',
            contactType: note.userContactId?.contactTypeId?.contactTypeName || '',
          });
        }
      });
    });
  
    // 3️⃣ Sort by most recently updated
    return allNotes.sort(
      (a, b) =>
        (new Date(b.userConversationAllNoteUpdateDate || b.userConversationContactNoteUpdateDate ) - new Date(a.userConversationAllNoteUpdateDate || a.userConversationContactNoteUpdateDate )) 
    );
  };

  const meetingConversations = extractMeetingConversations();
  // console.log('meeting conversations', meetingConversations)
  
  // 3 - Functions
  
  // 12 Jun 2025 - Extracted Actions
  const extractedActions = meetingConversations
  ?.filter(note => note.noteType === 'contact' && Array.isArray(note.userActionRefs))
  ?.flatMap(note => note.userActionRefs.map(ref => ({
    ...ref,
    sourceNoteId: note._id,
    contactName: note.contactName || '',
    contactType: note.contactType || ''
  }))) || [];

  // console.log('extractedActions', extractedActions)

  // 3a - Handle Toggle Details -
  const toggleDetails = () => setShowDetails(prev => !prev)
  
  // 3b - Handle Toggle Attendees -
  const toggleAttendees = () => setShowAttendees(prev => !prev)

  // 3c - Handle Toggle Note Details -23 Mar 2025
  const handleToggleNoteDetails = (noteId) => {
    setShowNoteDetails((prev) => ({
      ...prev,
      [noteId]: !prev[noteId],
    }))
  }
  
  // 3d - Handle Toggle Conversation Details - 25 Mar 2025
  const handleToggleConversationDetails = (noteId) => {
    setShowConversationDetails((prev) => ({
      ...prev,
      [noteId]: !prev[noteId],
    }))
  }

  // 3f - Toggle Action Detail - 10 Jun 2025
  const toggleExpandedActionDetails = (noteId) => {
    setExpandedActionDetails(prev => ({
      ...prev,
      [noteId]: !prev[noteId]
    }));
  };

  // 3g - Toggle Action Progress - 10 Jun 2025
  const toggleExpandedProgressTrail = (noteId) => {
    setExpandedProgressTrail(prev => ({
      ...prev,
      [noteId]: !prev[noteId]
    }));
  };
  
  // 4 - create Markup
  const createMarkup = (htmlContent) => {
    return { __html: htmlContent }
  }

  // 5 - Handle generateAIprep - 21 May 2025
  const handleGenerateAIPrep = async () => {
    if (!event._id || isGeneratingAI) return;

    setIsGeneratingAI(true);
    setAiGeneratedBrief("");

    const payload = {
      calendarMeetingId: event._id,
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_SERVER_URL}/userMeetingPreps/generateUserMeetingPrepBrief`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(payload),
        }
      );

      if (!response.ok || !response.body) {
        throw new Error("Failed to fetch AI prep stream.");
      }

      const reader = response.body.getReader();
      const decoder = new TextDecoder();
      let fullText = "";

      while (true) {
        const { done, value } = await reader.read();
        if (done) break;

        const chunk = decoder.decode(value, { stream: true });
        fullText += chunk;
        setAiGeneratedBrief((prev) => prev + chunk); // Streaming update
      }

    } catch (err) {
      console.error("Error during AI prep generation:", err);
      setAiGeneratedBrief("❌ Failed to generate AI prep.");
    } finally {
      setIsGeneratingAI(false);
    }
  };

  return (
    <div 
        // className='bg-white rounded m-1 p-1 border-b border-gray-300  shadow-md py-1 font-poppins'
        className={`rounded m-1 p-1 border-b shadow-md py-1 font-poppins transition-all ${
        isActive
        ? 'bg-gray-50 border border-orange-500'
        : 'bg-white border-gray-300 hover:bg-orange-50'
        }`}

        onClick={onClick}
    >
      {/* Header */}
      <div className='flex justify-between items-center'>
        <div className='flex justify-start items-center'>
            <div
            className="flex justify-center items-center cursor-pointer rounded-full h-5 w-5 hover:bg-white"
            onClick={toggleDetails}
            >
            {showDetails ? (
                <MinusIcon className="h-4 w-4 text-orange-600" />
            ) : (
                <PlusIcon className="h-4 w-4 text-orange-600" />
            )}
            </div>
            <p className='text-lg m-1 p-1 font-bold text-gray-600'>{index + 1}.</p>
            <p className='text-xs m-1 p-1 font-bold text-gray-600'>{event.title}</p>
        </div>
        <div className='flex justify-end items-center'>
            {/* 15 Jun 2025 */}
            <div className='flex justify-between items-center'>
              {event.hasPrep && (
                <div className='ml-2 flex justify-start items-center'>
                    <p className='text-xs mx-1 rounded-full px-2 py-[1px] bg-lime-400'>Prepped!</p>
                    {/* <CheckCircleIcon className="h-5 w-5 text-lime-600" /> */}
                </div>    
              )}
              {event.hasConversation && (
                <div className='ml-2 flex justify-start items-center'>
                    <p className='text-xs mx-1 rounded-full px-2 py-[1px] bg-yellow-400'>Captured!</p>
                    {/* <CheckCircleIcon className="h-5 w-5 text-lime-600" /> */}
                </div>    
              )}
              {!event.hasConversation && (
                <div className='ml-2 flex justify-start items-center'>
                    <p className='text-xs mx-1 rounded-full px-2 py-[1px] bg-red-400'>UnCaptured!</p>
                    {/* <CheckCircleIcon className="h-5 w-5 text-lime-600" /> */}
                </div>    
              )}
            </div>
            
        </div>
      </div>

      {/* Time */}
      <div className='flex justify-between items-center m-1 p-1 border-t'>
        <div className='flex justify-start items-center my-1 py-1'>
          <CalendarDaysIcon className='w-4 h-4 text-orange-600' />
          <p className='text-xs mx-1 px-1 text-orange-600'>
            {moment(event.startTime).isSame(moment(), 'day') ? "Today" : moment(event.startTime).format("DD MMM YYYY (ddd)")}
          </p>
        </div>
        <div className='flex justify-end items-center my-1 py-1'>
          <div className='flex items-center'>
            <ClockIcon className='text-lime-600 h-4 w-4' />
            <p className='text-xs mx-1 px-1'>Start: {moment(event.startTime).format("hh:mm A")}</p>
          </div>
          <div className='flex items-center'>
            <ClockIcon className='text-orange-600 h-4 w-4' />
            <p className='text-xs mx-1 px-1'>End: {moment(event.endTime).format("hh:mm A")}</p>
          </div>
        </div>
      </div>

      {/* Expandable Details */}
      {showDetails && (
          <div className='border-t m-1 p-1'>
            {/* Attendees */}
            <div className='p-2 flex justify-start items-center'>
              <div
                className="flex justify-center items-center cursor-pointer rounded-full h-5 w-5 hover:bg-white"
                onClick={toggleAttendees}
              >
                {showAttendees ? (
                  <MinusIcon className="h-4 w-4 text-orange-600" />
                ) : (
                  <PlusIcon className="h-4 w-4 text-orange-600" />
                )}
              </div>
              <UserGroupIcon className='h-5 w-5 text-orange-600' />
              <p className='text-sm font-bold mx-1 px-1'>Attendees:</p>
              <p className='text-xs text-gray-400 italic px-1'>
                {event?.attendees?.length} attendee{event?.attendees?.length !== 1 ? "s" : ""}
              </p>
            </div>

            {showAttendees && event?.attendees?.length > 0 && (
              event.attendees.map((attendee, i) => (
                <div key={`${attendee.email}-${i}`} className='bg-gray-300 rounded m-1 p-1'>
                  <div className='flex justify-start items-center'>
                    {/* <User
                      username={attendee?.username}
                      defaultUserPic={userProfileIcon2}
                    /> */}
                    <p className='text-[10px] mx-1 px-1 font-bold'>{i + 1}.</p>
                    <p className='text-[10px] mx-1 px-1'>{attendee?.email}</p>
                  </div>
                </div>
              ))
            )}

            {/* Show Prep */}
            {/* Meeting Prep Section */}
            <div className='border-t my-1 py-1'>
              <div className='flex justify-between items-center m-1 p-1'>
                <div className='flex justify-start items-center'>
                  <EtMeetingIcon1SVGComp className='h-6 w-6 text-orange-600' />
                  <p className='text-sm font-bold text-gray-600 mx-1 px-1'>Meeting Prep Trail</p>
                </div>
                <div className='flex justify-end items-center gap-2'>
                  {/* 21 May 2025 - Trinity AI guided prep (only for 1:1) */}
                  {isOneOnOneMeeting && (
                    <div className='flex justify-start items-center gap-1'>
                    <button
                      className="text-xs text-blue-600 underline"
                      onClick={() => {
                        setShowAIPrepModal(true);        // 🔓 Open the modal first
                        handleGenerateAIPrep();          // ⚙️ Then trigger the AI stream
                      }}
                    >
                      Trinity AI
                    </button>
                  
                  <p className='text-xs font-bold'>|</p>
                  </div>
                  )}
                  
                  <p className='text-xs font-bold mx-1 px-1'>Add</p>
                  <button
                    className="flex items-center bg-lime-500 text-white p-1 rounded text-xs hover:bg-lime-600"
                    onClick={() => setShowModal(true)}
                  >
                    <PlusIcon className="h-4 w-4" />
                  </button>
                </div>
                  
              </div>
              
              {/* Prep Notes Trail Section */}
              {matchingPrep?.meetingPrepNotes?.length > 0 ? (
                matchingPrep?.meetingPrepNotes
                ?.slice()
                  .sort(
                    (a, b) =>
                        new Date(b.meetingPrepNoteUpdateDate) - new Date(a.meetingPrepNoteUpdateDate)
                ) // Sort in descending order
                ?.map((note, i) => {

                    const noteText = note?.meetingPrepNoteText || ""
                    const noteDate = note?.meetingPrepNoteDate || ""
                    const noteUpdateDate = note?.meetingPrepNoteUpdateDate || ""
                    // console.log('noteText', noteText)
                  
                    return (
                  <div key={note._id+i} className="">

                    <div className='bg-gray-200 rounded grid grid-cols-11 justify-start items-center m-1 p-1'>
                      <div className="col-span-4 flex justify-start items-center">
                        <div
                          onClick={() => handleToggleNoteDetails(note._id)}
                          className="rounded-full h-6 w-6 hover:bg-white flex justify-center items-center cursor-pointer"
                        >
                          {showNoteDetails[note._id] ? (
                            <MinusIcon className="h-4 w-4 text-orange-600" />
                          ) : (
                            <PlusIcon className="h-4 w-4 text-orange-600" />
                          )}
                        </div>
                        <div>
                          <p className="text-sm font-bold mx-1 px-1 text-gray-600">{ i +1}.</p>
                        </div>
                        <div className="">
                          <p className="text-[8px] mx-1 rounded-full px-1 my-[1px] py-[1px] bg-lime-200 w-full">
                            {getTimeSince(noteUpdateDate)}
                          </p>
                          <p className="text-[7px] mx-1 italic px-1 py-[1px] text-gray-400">last updated</p>
                        </div>
                      </div>

                      <div className="col-span-6 flex justify-start items-center">
                        <div
                          dangerouslySetInnerHTML={createMarkup(noteText)}
                          className="text-[11px] text-gray-700 m-1 p-1 truncate max-w-full line-clamp-1"
                        ></div>
                      </div>

                      <div className="col-span-1 flex justify-start items-center">
                        <div className="rounded-full flex justify-center items-center h-6 w-6 hover:bg-white">
                          <PencilSquareIcon
                            className="h-4 w-4 p-[2px] text-orange-600 cursor-pointer"
                            onClick={() => {
                              setSelectedNoteId(note._id); // ✅ Set noteId for editing
                              setShowModal(true);
                            }}
                          />
                        </div>
                        <div className="rounded-full flex justify-center items-center h-6 w-6 hover:bg-white">
                          <TrashIcon
                            className="h-4 w-4 p-[2px] text-orange-600 cursor-pointer"
                            onClick={() => {
                              setSelectedNoteId(note._id); // ✅ Set noteId for editing
                              setIsDeletingNote(true);     // ✅ Set flag for deleting
                              setShowModal(true);
                            }}
                          />
                        </div>
                      </div>
                      
                    </div>

                    {showNoteDetails[note._id] && (
                      <div className='bg-orange-50 rounded m-1 p-1 max-h-1/2 overflow-y-auto fix-nested-lists'>
                        <p dangerouslySetInnerHTML={createMarkup(noteText)} className='text-xs leading-4 m-1 p-1'></p>
                        <div className='flex justify-between items-center m-1 p-1 border-t'>
                          <div className='flex justify-start items-center my-1'>
                            <ClockIcon className="h-5 w-5 text-lime-600" />
                            <p className="text-[10px] text-orange-600 font-bold mx-1 px-1">
                                Created:
                            </p>
                            <p className="text-[10px] text-gray-500">
                               {moment(noteDate).format('DD MMM, hh:mm A')}
                            </p>
                          </div>
                          <div className='flex justify-start items-center my-1'>
                            <ClockIcon className="h-5 w-5 text-lime-600" />
                            <p className="text-[10px] text-gray-500 font-bold mx-1 px-1">
                                Updated:
                            </p>
                            <p className="text-[10px] text-gray-500">
                                {moment(noteUpdateDate).format('DD MMM, hh:mm A')}
                            </p>
                          </div>
                          
                        </div>  
                      </div>
                    )}         
                  </div>
                )})
              ) : (
                <p className="text-xs italic text-gray-500">No prep notes yet.</p>
              )}
            </div>

            {/* Post Meeting Trail */}
            <div className='border-t m-1 p-1'>
              <div className=''>
                <p className='text-sm font-bold text-gray-600 m-1 p-1'>Post Meeting Trail</p>
                
                {/* Action Areas -  */}
                <div className='flex justify-between items-center my-1 py-1 bg-gray-100'>
                  <div 
                    className='flex justify-start items-center mx-1 px-1 cursor-pointer'
                    onClick={() => setActivePostTab('conversations')}  
                  >
                      <EtWabConversationIcon1SVGComp className='h-6 w-6 text-orange-600'/>
                      <p className={`text-[10px] font-bold mx-1 ${activePostTab === 'conversations' ? 'border-b-2 border-orange-600': ''}`}>Conversations</p>
                  </div>
                  <div 
                    className='flex justify-start items-center mx-1 px-1 cursor-pointer'
                    onClick={() => setActivePostTab('actions')}
                  
                  >
                      <EtWabActionIcon1SVGComp className='h-6 w-6 text-orange-600'/>
                      <p className={`text-[10px] font-bold mx-1 ${activePostTab === 'actions' ? 'border-b-2 border-orange-600': ''}`}>Actions</p>
                  </div>
                  <div 
                    className='flex justify-start items-center mx-1 px-1 cursor-pointer'
                    onClick={() => setActivePostTab('transcript')}
                  
                  >
                      <ShareIcon className='h-4 w-4 text-orange-600'/>
                      <p className={`text-[10px] font-bold mx-1 ${activePostTab === 'transcript' ? 'border-b-2 border-orange-600': ''}`}>Transcript</p>
                  </div>
                </div>

                {activePostTab === 'conversations' && (
                  <div className="bg-white rounded p-2 text-xs mt-2">
                    <div className='flex justify-between items-center m-1 p-1'>
                      <div className='flex justify-start items-center'>
                        <EtMeetingIcon2SVGComp className='h-6 w-6 text-orange-600' />
                        <p className='text-sm font-bold text-gray-600 mx-1 px-1'>Conversations Trail</p>
                      </div>
                      <div className='flex justify-end items-center'>
                        <p className='text-xs font-bold mx-1 px-1'>Add</p>
                        <button
                          className="flex items-center bg-lime-500 text-white p-1 rounded text-xs hover:bg-lime-600"
                          onClick={() => setShowConversationModal(true)}
                        >
                          <PlusIcon className="h-4 w-4" />
                        </button>
                      </div>
                    </div>

                    {/* You can later replace this placeholder with an editor or conversation log component */}
                    {meetingConversations?.length > 0 ? (
                          meetingConversations
                          ?.slice()
                            .sort(
                              (a, b) =>
                                  (new Date(b.userConversationAllNoteUpdateDate || b.userConversationContactNoteUpdateDate) - new Date(a.userConversationAllNoteUpdateDate || a.userConversationContactNoteUpdateDate ))
                          ) // Sort in descending order
                          ?.map((note, idx) => {
                            const noteType = note?.noteType || ""
                            const contactName = note?.contactName || ""
                            const contactType = note?.contactType || ""
                            const noteText = note?.userConversationAllNoteText || note?.userConversationContactNoteText || ""
                            const noteDate = note?.userConversationAllNoteDate || note?.userConversationContactNoteDate || ""
                            const noteUpdateDate = note?.userConversationAllNoteUpdateDate || note?.userConversationContactNoteUpdateDate || ""
                            
                            console.log('note conversation', note)

                            return (
                            <div key={note._id + idx} className="">

                                <div className='bg-gray-200 rounded grid grid-cols-11 justify-start items-center m-1 p-1'>
                                  <div className="col-span-4 flex justify-start items-center">
                                    <div
                                      onClick={() => handleToggleConversationDetails(note._id)}
                                      className="rounded-full h-6 w-6 hover:bg-white flex justify-center items-center cursor-pointer"
                                    >
                                      {showConversationDetails[note._id] ? (
                                        <MinusIcon className="h-4 w-4 text-orange-600" />
                                      ) : (
                                        <PlusIcon className="h-4 w-4 text-orange-600" />
                                      )}
                                    </div>
                                    <div>
                                      <p className="text-sm font-bold mx-1 px-1 text-gray-600">{ idx +1}.</p>
                                    </div>
                                    <div className="">
                                      <p className="text-[8px] mx-1 rounded-full px-1 my-[1px] py-[1px] bg-lime-200 w-full">
                                        {getTimeSince(noteUpdateDate)}
                                      </p>
                                      <p className="text-[7px] mx-1 italic px-1 py-[1px] text-gray-400">last updated</p>
                                    </div>
                                  </div>

                                  <div className="col-span-6 flex justify-start items-center">
                                    <div
                                      dangerouslySetInnerHTML={createMarkup(noteText)}
                                      className="text-[11px] text-gray-700 m-1 p-1 truncate max-w-full line-clamp-1"
                                    ></div>
                                  </div>

                                  <div className="col-span-1 flex justify-start items-center">
                                    <div className="rounded-full flex justify-center items-center h-6 w-6 hover:bg-white">
                                      <PencilSquareIcon
                                        className="h-4 w-4 p-[2px] text-orange-600 cursor-pointer"
                                        onClick={() => {
                                          setSelectedConversationNoteId(note._id); // ✅ Set noteId for editing
                                          setShowConversationModal(true);
                                        }}
                                      />
                                    </div>
                                    <div className="rounded-full flex justify-center items-center h-6 w-6 hover:bg-white">
                                      <TrashIcon
                                        className="h-4 w-4 p-[2px] text-orange-600 cursor-pointer"
                                        onClick={() => {
                                          setSelectedConversationNoteId(note._id); // ✅ Set noteId for editing
                                          setIsDeletingConversationNote(true);     // ✅ Set flag for deleting
                                          setShowConversationModal(true);
                                        }}
                                      />
                                    </div>
                                  </div>
                                </div>

                                {showConversationDetails[note._id] && (
                                    <div className='bg-orange-50 rounded m-1 p-1 fix-nested-lists'>
                                      <p dangerouslySetInnerHTML={createMarkup(noteText)} className='text-xs leading-4 m-1 p-1'></p>
                                      <div className='flex justify-between items-center m-1 p-1 border-t'>
                                        <div className='flex justify-start items-center my-1'>
                                          <ClockIcon className="h-5 w-5 text-lime-600" />
                                          <p className="text-[10px] text-orange-600 font-bold mx-1 px-1">
                                              Created:
                                          </p>
                                          <p className="text-[10px] text-gray-500">
                                            {moment(noteDate).format('DD MMM, hh:mm A')}
                                          </p>
                                        </div>
                                        <div className='flex justify-start items-center my-1'>
                                          <ClockIcon className="h-5 w-5 text-lime-600" />
                                          <p className="text-[10px] text-gray-500 font-bold mx-1 px-1">
                                              Updated:
                                          </p>
                                          <p className="text-[10px] text-gray-500">
                                              {moment(noteUpdateDate).format('DD MMM, hh:mm A')}
                                          </p>
                                        </div>   
                                      </div>  
                                    </div>
                                 )}  
                              </div>
                          )})
                        ) : (
                          <p className="text-xs italic text-gray-500 mt-2">No conversations added yet.</p>
                     )}
                  </div>
                )}

                {/* Placeholder for other tabs */}
                {/* {activePostTab === "actions" && (
                  <div className="bg-gray-100 rounded mt-2 p-2">
                    <p className="text-xs italic text-gray-500">Actions coming soon...</p>
                  </div>
                )} */}

                {activePostTab === "actions" && (
                  <div className="bg-white rounded mt-2 p-2">
                    <p className="text-sm font-bold text-gray-700 mb-2">Linked Actions</p>

                    {extractedActions?.length > 0 && extractedActions?.map((action, actionIndex) => {
                                
                                const actionId = action?.userActionId?._id || null
                                const userId = action?.userActionId?.userId || null
                                const userOrgId = action?.userActionId?.userOrgId || null
                                const trailId = action?.userActionId?.trailId || null
                                const sessionId = action?.userActionId?.sessionId || null
                                const actionTypeId = action?.userActionId?.actionTypeId || null
                                const actionName = action?.userActionId?.userActionName || ""
                                const actionDesc = action?.userActionId?.userActionDesc || ""
                                const completeBy = action?.userActionId?.completeBy || ""
                                const progress = action?.userActionId?.userActionProgress || 0
                                const actionNotes = action?.userActionId?.userActionNotes || []
                                const createdAt = action?.userActionId?.createdAt || ""
                                const updatedAt = action?.userActionId?.updatedAt || ""
                                // Action Data for Action Update
                                const actionData = {
                                  _id: actionId,
                                  userId: userId,
                                  userOrgId: userOrgId,
                                  trailId: trailId,
                                  sessionId: sessionId,
                                  actionTypeId: actionTypeId,
                                  userActionName: actionName,
                                  userActionDesc: actionDesc,
                                  completeBy:completeBy,
                                }
                                
                                return(
                                  <div key={action._id + actionIndex} className="bg-gray-200 rounded m-1 p-1">
                                    {/* Action Header Bar */}
                                    <div className="grid grid-cols-10 justify-between items-center m-1 p-1">
                                      <div className="col-span-1 flex justify-start items-center">
                                        <div
                                          className="flex justify-center items-center cursor-pointer rounded-full h-5 w-5 hover:bg-white"
                                          onClick={()=>toggleExpandedActionDetails(action._id)}
                                        >
                                          {expandedActionDetails[action._id] ? (
                                            <MinusIcon className="h-4 w-4 text-orange-600" />
                                          ) : (
                                            <PlusIcon className="h-4 w-4 text-orange-600" />
                                          )}
                                        </div>
                                        <p className="mx-1 px-1 text-lg font-bold text-gray-600">{actionIndex +1}.</p>
                                        {/* <div className="">
                                          <p className="text-[8px] mx-1 rounded-full px-1 my-[1px] py-[1px] bg-lime-200 w-full">
                                            {getTimeSince(updatedAt)}
                                          </p>
                                          <p className="text-[7px] mx-1 italic px-1 py-[1px] text-gray-600">last updated</p>
                                        </div> */}

                                      </div>
                                      <div className="col-span-5 flex justify-start items-center">
                                        {/* <p className="mx-1 px-1 text-xs font-bold text-gray-600">Action: </p> */}
                                        <div
                                          dangerouslySetInnerHTML={createMarkup(actionName)}
                                          className="text-[11px] text-gray-700 m-1 p-1 truncate max-w-full line-clamp-1"
                                        ></div>
                                      </div>
                                      <div className='col-span-1 flex justify-center items-center'>
                                        <div className='h-10 w-10 z-0 relative'>
                                          <CircularProgressbarWithChildren
                                            value={progress}
                                            circleRatio={0.75}
                                            styles={{
                                              path: { stroke: '#552a9a', transform: 'rotate(-135deg)', transformOrigin: 'center center' },
                                              trail: { stroke: '#d6d6d6', transform: 'rotate(-135deg)', transformOrigin: 'center center' }
                                            }}
                                          >
                                            <div><p className='text-xs font-bold text-orange-600'>{progress}%</p></div>
                                          </CircularProgressbarWithChildren>
                                        </div>
                                      </div>
                                      <div className="col-span-3 flex justify-end items-center">
                                        <div className="flex justify-between items-center">
                                          <div className="flex justify-start items-center">
                                            <ClockIcon className="h-5 w-5 text-lime-600" />
                                            <div>
                                              <p className="text-[10px] rounded-full mx-[2px] font-semibold px-1 bg-white border border-orange-600 hover:bg-orange-600 hover:text-white text-gray-800">
                                                  {/* {moment(completeBy).format('DD MMM, hh:mm A')} */}
                                                  {moment(completeBy).format('DD MMM YYYY')}
                                              </p>
                                              {/* <p className="text-[10px] text-gray-600 mx-[2px] mt-1">
                                                  Complete By:
                                              </p> */}
                                            </div>    
                                          </div>
                                          <div className="ml-1 pl-1">
                                            <div className="rounded-full flex justify-center items-center h-6 w-6 hover:bg-white">
                                              <PencilSquareIcon
                                                className="h-5 w-5 p-[2px] text-orange-600 cursor-pointer"
                                                onClick={() => {
                                                  setSelectedAction(actionData)
                                                  setShowUpdateModal(true)
                                                }}
                                              />
                                            </div>
                                          </div> 
                                        </div>    
                                      </div>
                                    </div>
                                                                     
                                    {/* Action & Progress Details */}
                                    {expandedActionDetails[action._id] && (
                                    
                                    <div>
                                      <div className="bg-orange-50 rounded m-1 p-1">
                                        <p className="mx-1 px-1 font-bold">Details</p>
                                        <div className="m-1 p-1 text-xs leading-4 text-gray-600">
                                          <span className="">{actionName}</span> <span dangerouslySetInnerHTML={createMarkup(" " + actionDesc)} />
                                        </div>

                                        <div className="flex justify-between items-center border-t py-2">
                                            <div className="">
                                              <p className="text-[8px] mx-1 rounded-full px-1 my-[1px] py-[1px] bg-lime-200 w-full">
                                                {getTimeSince(updatedAt)}
                                              </p>
                                              <p className="text-[7px] mx-1 italic px-1 py-[1px] text-gray-600">last updated</p>
                                            </div>
                                            <div className="flex justify-start items-center mx-1 px-1">
                                              <ClockIcon className="h-5 w-5 text-lime-600" />
                                                <p className="text-[10px] text-orange-600 font-bold mx-1 px-1">
                                                    Created:
                                                </p>
                                                <p className="text-[10px] text-gray-500">
                                                    {moment(createdAt).format('DD MMM, hh:mm A')}
                                                </p>
                                            </div>
                                            <div className="flex justify-start items-center mx-1 px-1">
                                              <ClockIcon className="h-5 w-5 text-lime-600" />
                                                <p className="text-[10px] text-orange-600 font-bold mx-1 px-1">
                                                    Updated:
                                                </p>
                                                <p className="text-[10px] text-gray-500">
                                                    {moment(updatedAt).format('DD MMM, hh:mm A')}
                                                </p>
                                            </div>
                                          </div>
                                      </div>

                                      <div className="bg-white rounded m-1 p-1">

                                        <div className="flex justify-start items-center">
                                          <div
                                              className="flex justify-center items-center cursor-pointer rounded-full h-5 w-5 hover:bg-white"
                                              onClick={()=>toggleExpandedProgressTrail(action._id)}
                                            >
                                              {expandedProgressTrail[action._id] ? (
                                                <MinusIcon className="h-4 w-4 text-orange-600" />
                                              ) : (
                                                <PlusIcon className="h-4 w-4 text-orange-600" />
                                              )}
                                            </div>

                                            <div>
                                              <p className="mx-1 px-1 font-bold">Progress Trail</p>
                                              <p className="mx-1 px-1 text-xs">See the progress of this action</p>
                                            </div>  
                                        </div>                     
                                        {/* Trail Placeholder */}
                                        {expandedProgressTrail[action._id] && actionNotes?.length > 0 && (
                                          <div className="border-t mt-2 pt-2">
                                            
                                            {actionNotes
                                              ?.slice()
                                              ?.sort((a, b) => new Date(b.actionNoteDate) - new Date(a.actionNoteDate))
                                              ?.map((note, noteIndex) => {
                                                const noteText = note?.actionNoteText || ""
                                                const noteDate = note?.actionNoteDate || ""
                                                const noteProgress = note?.actionNoteProgress || 0

                                                return (
                                                  <div key={note._id + noteIndex} className='bg-gray-50 rounded my-1 p-2 border-b'>
                                                    <div className='grid grid-cols-5 justify-start items-center'>
                                                      <div className="col-span-1 flex flex-col justify-center items-center ">
                                                        <div className='h-10 w-10 mr-2'>
                                                        <CircularProgressbarWithChildren
                                                          value={noteProgress}
                                                          circleRatio={0.75}
                                                          styles={{
                                                            path: { stroke: '#552a9a', transform: 'rotate(-135deg)', transformOrigin: 'center center' },
                                                            trail: { stroke: '#d6d6d6', transform: 'rotate(-135deg)', transformOrigin: 'center center' }
                                                          }}
                                                        >
                                                          <div><p className='text-[12px] font-bold'>{noteProgress}%</p></div>
                                                        </CircularProgressbarWithChildren>
                                                      </div>
                                                        <p className='text-[10px] rounded-full px-2 my-[1px] py-[1px] bg-yellow-300 inline-block'>{getTimeSince(noteDate)}</p>
                                                      </div>
                                                      <div className="col-span-4 flex-1">
                                                        <p className='m-1 p-1'>{noteText}</p>
                                                        
                                                      </div>
                                                    </div>
                                                  </div>
                                                )
                                              })}
                                          </div>
                                        )}

                                        {expandedProgressTrail[action._id] && actionNotes?.length === 0 && (
                                          <p className='text-xs italic text-gray-500'>No progress updates yet.</p>
                                        )}

                                      </div>

                                    </div>
                                    )}
                                    {/* Modal to update the action - 04 Apr 2025 */}
                                          {showUpdateModal && selectedAction && (
                                            <EtModalUpdateUserAction
                                              isOpen={showUpdateModal}
                                              onClose={() => {
                                                setShowUpdateModal(false);
                                                setSelectedAction(null);
                                              }}
                                              actionId={selectedAction._id}
                                              actionData={selectedAction}
                                              refetchUserActions={refetchUserConversations}
                                            />
                                          )}
                                    
                                  </div>
                                )
                    })}

                    {extractedActions?.length === 0 && (<div>
                      <p className="text-xs italic text-gray-500">
                        No actions have been created for this conversation yet.
                      </p>
                    </div>
                    )}
                  </div>
                )}



                {activePostTab === "transcript" && (
                  <div className="bg-gray-100 rounded mt-2 p-2">
                    <p className="text-xs italic text-gray-500">Transcript feature coming soon...</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
        
        {showModal && (
        <EtModalUpdateUserMeetingPrep
          isOpen={showModal}
          id={matchingPrep._id}
          noteId={selectedNoteId}   // ✅ 22 Mar 2025 - pass selected noteId
          isDelete={isDeletingNote} // ✅ 22 Mar 2025 - pass delete flag
          userId={matchingPrep.userId}
          userOrgId={matchingPrep.userOrgId}
          triggeringUrl={"/etapp"} // Or null, if staying on the same page
          onClose={() => {
            setShowModal(false);
            setSelectedNoteId(null); // ✅ 22 Mar 2025 - reset after modal close
            setIsDeletingNote(false) // ✅ 22 Mar 2025 - reset after modal close
          }}
        />)}
        {showConversationModal && (
          <EtModalTrinityUserMeetingConversation
            isOpen={showConversationModal}
            userId={matchingPrep?.userId}
            noteId={selectedConversationNoteId}
            isDelete={isDeletingConversationNote}
            userOrgId={matchingPrep?.userOrgId}
            calendarMeetingId={matchingPrep?.calendarMeetingId}
            userMeetingPrepId={matchingPrep?._id}
            onClose={() => {
              setShowConversationModal(false)
              setSelectedConversationNoteId(null); // ✅ 25 Mar 2025 - reset after modal close
              setIsDeletingConversationNote(false) // ✅ 25 Mar 2025 - reset after modal close
            }}
            refetchUserConversations={refetchUserConversations} // ✅ 25 Mar 2025
            relevantContacts={relevantContacts} // ✅ 12 Jun 2025
          />
        )}

        {/* 🔽 PLACE THIS MODAL JSX HERE */}
        {showAIPrepModal && (
          <div className="fixed inset-0 z-[999] flex items-center justify-center bg-black bg-opacity-50 font-poppins">
            <div className="bg-white p-6 rounded-lg shadow-lg max-w-2xl w-full">
              <div className="flex justify-between items-center mb-4">
                <h2 className="text-lg font-bold text-gray-700">Trinity AI Meeting Prep Brief</h2>
                <button
                  onClick={() => setShowAIPrepModal(false)}
                  className="text-sm text-orange-600 hover:text-red-600 font-bold"
                >
                  Close
                </button>
              </div>

              <div className="bg-gray-100 p-4 rounded max-h-96 overflow-y-auto text-sm whitespace-pre-wrap leading-relaxed text-gray-800">
                {isGeneratingAI ? "Trinity is crafting your meeting brief..." : aiGeneratedBrief}
              </div>
            </div>
          </div>
        )}

    </div>
  )
}

export default EtPostMeetingCard